import React, { useCallback, useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import { useSelector } from "react-redux";
import { USER_ROLES } from "static/constants";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const ReportPreviewModal = ({
  report,
  onClose,
  isModalOpen,
  handleReportDownload,
  handleSendToTransmission,
}) => {
  const [numPages, setNumPages] = useState(null);
  const { currentUser } = useSelector((state) => state.auth);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const initialActionButtons = [
    {
      label: "Cancel",
      variant: "outlined",
      onClick: onClose,
    },
    {
      label: "Download",
      variant: "contained",
      color: "info",
      onClick: handleReportDownload,
    },
  ];

  const [actionButtons, setActionButtons] = useState(initialActionButtons);

  const loadActionButtons = useCallback(() => {
    const label = "Send to Transmissions";
    const sendToTransmissionButton = {
      label,
      variant: "contained",
      color: "secondary",
      onClick: handleSendToTransmission,
    };

    if (
      [USER_ROLES.USER, USER_ROLES.ADMIN, USER_ROLES.CLINIC_ADMIN].includes(
        currentUser?.role
      )
    ) {
      setActionButtons((prevState) => [...prevState, sendToTransmissionButton]);
    }
  }, [currentUser]);

  useEffect(() => {
    loadActionButtons();
  }, [loadActionButtons]);

  return (
    <ModalWrapper
      title="Report Preview"
      show={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      showContentDivider
      actionButtons={actionButtons}
    >
      <Document
        file={report}
        onLoadSuccess={onDocumentLoadSuccess}
        loading="Loading PDF..."
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} />
        ))}
      </Document>
    </ModalWrapper>
  );
};

export default ReportPreviewModal;
